const ruleForUserName = value => {
  return value && !/^\s+$/.test(value);
};

export default ruleForUserName;



// WEBPACK FOOTER //
// ./src/utils/validations/ruleForUserName.js